module.exports = __webpack_public_path__ + "Server-Unavailable.TentacleActive.61054b6c2f7afeda89c9ea862081613e.hashedasset.svg";